import Loading from "./partial/Loading.js";
import addgroup from "../media/addgroup.png";
import { _createGroup } from "../data/groups";
import { _getUserGroups } from "../data/users";
import { _saveUserDisplayName } from '../data/users.js';
import { firebaseObserver, loggedIn } from "../utils/firebase";
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { toggleModal } from "../utils/uiUtils.js";
import { useEffect, useState } from "react";
import { useGroupSummaryStore } from "../stores/useGroupSummaryStore.js";
import { useNavigate } from "react-router-dom";
import { useCurrentGroupStore } from "../stores/useCurrentGroupStore.js";


function MainPage() {
    const [isLoading, setIsLoading] = useState(true);
    const [newGroupName, setNewGroupName] = useState("");

    const getGroups = useGroupSummaryStore((state) => state.fetchGroups);
    const groups = useGroupSummaryStore((state) => state.groups);
    const navigate = useNavigate();

    const createGameGroup = async () => {
        if (newGroupName === "") return;
        const groupId = await _createGroup(newGroupName);
        useGroupSummaryStore.getState().clearGroups();
        navigate('/group/' + groupId);
    };

    const init = async () => {
        if (loggedIn()) {
            getGroups().then(() => {
                setIsLoading(false);
            });
        }
    }

    const goToGroup = (groupId) => {
        useCurrentGroupStore.getState().fetchGroup(groupId, true);
        navigate('/group/' + groupId);
    }

    useEffect(() => {
        firebaseObserver.subscribe('authStateChanged', async (isUserLoggedIn) => {
            init();
        });

    }, []);

    useEffect(() => {
        init();
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <section className="container indent-from-top">
                <div className="columns mt-5">
                    {!groups &&
                        <div className="column is-3-desktop is-12-mobile">
                            <div className="card">
                                <header className="card-header">
                                    <p className="card-header-title">
                                        Create New Group
                                    </p>
                                </header>
                                <div className="card-content pt-2">
                                    <div className="content">
                                        <div className="mb-2 is-size-7">
                                            Create a new group. Invite friends, track plays, ratings and stats.
                                        </div>
                                        <div className="field">
                                            <div className="control">
                                                <input className="input" id="newGroupName" type="text" placeholder="Group Name" onChange={(e) => setNewGroupName(e.target.value)} />
                                                <button className="button is-primary" onClick={() => { createGameGroup(); }}>Create</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {groups &&
                    <>
                        <div className="columns">
                            <div className="column is-12-desktop is-12-mobile">
                                <div className="grid">
                                    {Object.keys(groups).sort((a, b) => { return groups[a].displayName.localeCompare(groups[b].displayName) }).map((group, index) => {
                                        var groupId = group;
                                        return (
                                            <div key={"group" + index} className="is-clickable cell" onClick={() => { goToGroup(groupId) }}>
                                                <article className="box has-background-primary-80">
                                                    <figure className="image is-96x96 ml-auto mr-auto">
                                                        <img
                                                            src={groups[groupId].icon}
                                                            alt="Group Icon"
                                                            className="is-clickable"
                                                        />
                                                    </figure>
                                                    <p className="subtitle has-text-centered">{groups[groupId].displayName}</p>
                                                </article>
                                            </div>
                                        );
                                    })}
                                    <div className="is-clickable cell" onClick={() => { toggleModal("modal-addGroup") }}>
                                        <article className="box has-background-primary-80">
                                            <figure className="image is-96x96 ml-auto mr-auto">
                                                <img src={addgroup} alt="Add new group" className="is-clickable" />
                                            </figure>
                                            <p className="subtitle has-text-centered mt-1">Add Group</p>
                                        </article>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="modal-addGroup" className="modal pl-3 pr-5">
                            <div className="modal-background"></div>
                            <div className="modal-card">
                                <header className="modal-card-head has-text-centered">
                                    <p className="modal-card-title">Add New Group</p>
                                    <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-addGroup') }}></button>
                                </header>
                                <section className="modal-card-body">
                                    <div className="is-size-6">
                                        <div className="field">
                                            <label className="label">Enter Group Name</label>
                                            <div className="control">
                                                <input className="input" id="groupName" type="text" placeholder="Text input" onChange={(e) => setNewGroupName(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <footer className="modal-card-foot">
                                    <button className="button is-primary mr-5" onClick={() => { createGameGroup(); }}>Create Group</button>
                                    <button className="button ml-5" aria-label="close" onClick={() => { toggleModal('modal-addGroup') }}>Close</button>
                                </footer>
                            </div>
                        </div>

                    </>
                }
            </section>
        </>
    );
}

export default MainPage;